import * as Switch from "@radix-ui/react-switch";
import { cva, cx } from "cva";
import type { FunctionComponent } from "react";
import type { SwitchProps } from "@radix-ui/react-switch";
import type { VariantProps } from "cva";
import type { Simplify } from "type-fest";
import type { ToggleSize } from "./Toggle.types";

const toggleRecipe = cva({
  base: "kn-toggle",
  variants: {
    size: {
      large: "kn-toggle-large",
      small: "kn-toggle-small",
    } satisfies Record<ToggleSize, string>,
  },
});

const switchThumbRecipe = cva({
  base: "kn-toggle-thumb",
  variants: {
    size: {
      large: "kn-toggle-thumb-large",
      small: "kn-toggle-thumb-small",
    } satisfies Record<ToggleSize, string>,
  },
});

type ToggleVariants = Simplify<VariantProps<typeof toggleRecipe>>;

export type ToggleProps = SwitchProps &
  ToggleVariants & {
    thumbClassName?: string;
  };

export const Toggle: FunctionComponent<ToggleProps> = ({
  size = "large",
  className,
  thumbClassName,
  ...props
}) => {
  return (
    <Switch.Root {...props} className={cx(toggleRecipe({ size }), className)}>
      <Switch.Thumb className={cx(switchThumbRecipe({ size }), thumbClassName)} />
    </Switch.Root>
  );
};

Toggle.displayName = "Toggle";

export default Toggle;
